import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  isDevMode,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { cloneDeep, each, find, findIndex, forEach, groupBy, has, identity, isArray, isEmpty, isEqual, map, orderBy } from 'lodash';

import { TicketsAssignService } from './tickets-assign.service';
import { WORK_SHIFT_PATHS } from '../../../work-shift';
import { forkJoin, Observable, Subject } from 'rxjs';
import { Enums } from '../../../../../configs/Enums';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../../../../../shared/modals/confirm-modal/confirm-modal.component';
import { DeactivationGuarded } from '../../../../../classes/canDeactivate';
import { TicketsAssignErrorModalComponent } from './components/tickets-assign-error-modal/tickets-assign-error-modal.component';
import { TicketViewService } from '../../../../tickets/ticket-view/ticket-view.service';
import { TicketsMatrixComponent } from './components/tickets-matrix/tickets-matrix.component';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';
import { TicketsService } from './components/services/tickets.service';
import { TicketTypesEnum } from '../../constants/ticket-types.constant';
import { AuthGroupTypesEnum } from '../../../../auth/auth-group-types.enum';
import { SectorRole } from '../../../../sectors/sectors';
import { ITicketType } from '../../../../check-lists-page/interfaces/ticket-type.interface';
import { IGlobalProblemSubtype } from '../../../../check-lists-page/interfaces/global-problem-subtype.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-assign',
  templateUrl: './tickets-assign.component.html',
  styleUrls: ['./tickets-assign.component.scss'],
  providers: [TicketsService],
  standalone: false,
})
export class TicketsAssignComponent implements OnInit, OnDestroy, DeactivationGuarded {
  private _destroyed$ = new Subject<void>();
  public moment = require('moment');
  public dateShortFormat = Enums.dates.shortFormat;
  public dateFullFormat = Enums.dates.fullFormat;

  public parentParams = { sectorSelected: null };
  public childParams: any = {
    int_begin: '',
    int_end: '',
    districts_ids: '',
    address: '',
    tickets_types_ids: '',
    brigades_ids: '',
    hd_ticket_number: '',
    ticket_status: '',
    hd_ticket_status_group: '',
    gp_types: '',
    gp_subtypes: '',
    responsible_groups: '',
    responsible_users: '',
  };

  public childParamsDefault = cloneDeep(this.childParams);

  public loading = false;

  public ticketsPeriodFilter = {
    data: {
      districts: null,
      ticketsTypes: null,
      brigades: null,
      ticketsHdStatuses: null,
      ticketsVkStatuses: null,
      typeGPs: null,
      subtypeGPs: null,
      allSubtypeGPs: null,
      responsibleGroups: null,
      responsibleUsers: null,
      allResponsibleUsers: null,
    },
    dateRange: {
      startDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().startOf('day')._d,
        currentDate: this.moment().startOf('day')._d,
      },
      endDate: {
        options: null,
        dateObj: null,
        initDate: this.moment().endOf('day')._d,
        currentDate: this.moment().endOf('day')._d,
      },
    },
    districtsSelected: null,
    address: null,
    typeGPSelected: null,
    appliedTypeGPs: null,
    appliedSubtypeGPs: null,
    subtypeGPSelected: null,
    ticketTypesSelected: null,
    appliedSubtypeGPSelected: null,
    brigadesSelected: null,
    ticketNumber: null,
    ticketHdStatusesSelected: null,
    ticketsVkStatusesSelected: null,
    responsibleGroupsSelected: null,
    responsibleUsersSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    resetFilter: () => {
      this.resetPeriodFilter();
    },
    exportFilter: () => {
      this.exportPeriodFilter();
    },
    syncGPSubtypesBasedOnTypes: null, // будет установлен в ngOnInit
    syncResponsibleUsersBasedOnGroups: null, // будет установлен в ngOnInit
  };
  public ticketsPeriodFilterDefault = cloneDeep(this.ticketsPeriodFilter);
  public ticketsCurrentFilter = {
    mode: this.getMode(),
    assignDaysList: [
      { id: 1, name: 'Сегодня', countDays: 0 },
      { id: 2, name: 'Завтра', countDays: 1 },
    ],
    assignDaySelected: null,
    currentFilterTypes: {
      assigned: {
        counts: 0,
        ticketStatuses: [2, 3, 6, 7, 8],
        id: 'assigned',
      },
      unassigned: { counts: 0, ticketStatuses: [1], id: 'unassigned' },
      opened: { counts: 0, ticketStatuses: [14], id: 'opened' },
      needActions: {
        counts: 0,
        ticketStatuses: [4, 5, 9],
        id: 'needActions',
      },
      all: { counts: 0, ticketStatuses: [], id: 'all' },
    },
    currentFilterTypeSelected: null,
    applyFilter: () => {
      this.applyPeriodFilter();
    },
    ticketsSettings: null,
    changeDayForAssigment: this.changeDayForAssigment.bind(this),
    changeTypeSelected: this.changeTypeSelected.bind(this),
    onChangeMode: this.onChangeMode.bind(this),
    resetTicketStatus: this.resetTicketStatus.bind(this),
    recalculateStatusAndTickets: () => {
      this.recalculateStatusAndTickets((ticket) => {
        const selectedTypeGPs = this.ticketsPeriodFilter.appliedTypeGPs.filter((appliedGP) => appliedGP.selected);
        const selectedSubtypeGPs = this.ticketsPeriodFilter.appliedSubtypeGPSelected;

        const correctTypeGP = selectedTypeGPs.findIndex((typeGP) => ticket.hd_ticket_type.id === typeGP.id) !== -1;
        const correctSubtypeGP = selectedSubtypeGPs.length ? selectedSubtypeGPs.findIndex((subtypeGP) => ticket.extra_flags.gp_subtype === subtypeGP.id) !== -1 : true;

        return correctTypeGP && correctSubtypeGP;
      });
    },
  };
  public ticketsCurrentFilterDefault = cloneDeep(this.ticketsCurrentFilter);
  public ticketsMultipleAssign = {
    brigades: null,
    brigadeSelected: null,
    ticketsChecked: null,
    isExistCheckedTicket: false,
    isMapSelectionMode: false,
    onChangeBrigadeForAssigment: this.onChangeBrigadeForAssigment.bind(this),
    onCheckedTicket: this.onChangeCheckedTicket.bind(this),
    onAddTicketsToBrigades: this.onAddTicketsToBrigades.bind(this),
    onToggleMapSelectionMode: this.onToggleMapSelectionMode.bind(this),
    onToggleMapTicket: this.onToggleMapTicket.bind(this),
    canAssignTicket: this.canAssignTicket.bind(this),
    hasPendingMapAssignment: this.hasPendingMapAssignment.bind(this),
    cancelMapTicketAssignment: this.cancelMapTicketAssignment.bind(this),
    ticketsListRefresh: this.ticketsListRefresh.bind(this),
    onResetCheckedTickets: this.onResetCheckedTickets.bind(this),
  };
  public ticketsMultipleAssignDefault = cloneDeep(this.ticketsMultipleAssign);
  public tickets = {
    data: null,
    dataTable: null,
    dataMatrix: null,
    dataFlatList: null,
    ticketsLoading: false,
  };
  public brigadeAssignData = {
    brigades: [],
    isAssignedSuccess: false,
    isAssignedLoading: false,
    assignBrigades: () => {
      this.assignBrigades();
    },
    addBrigade: (obj) => {
      this.addAssignBrigade(obj);
    },
    removeBrigade: (obj) => {
      this.removeAssignBrigade(obj);
    },
  };
  public intervals = [
    {
      index: 0,
      interval: '00.00 - 12.00',
      startTime: { hours: 0, minutes: 0, seconds: 0 },
      endTime: { hours: 11, minutes: 59, seconds: 59 },
    },
    {
      index: 1,
      interval: '12.00 - 14.00',
      startTime: { hours: 12, minutes: 0, seconds: 0 },
      endTime: { hours: 13, minutes: 59, seconds: 59 },
    },
    {
      index: 2,
      interval: '14.00 - 16.00',
      startTime: { hours: 14, minutes: 0, seconds: 0 },
      endTime: { hours: 15, minutes: 59, seconds: 59 },
    },
    {
      index: 3,
      interval: '16.00 - 18.00',
      startTime: { hours: 16, minutes: 0, seconds: 0 },
      endTime: { hours: 17, minutes: 59, seconds: 59 },
    },
    {
      index: 4,
      interval: '18.00 - 20.00',
      startTime: { hours: 18, minutes: 0, seconds: 0 },
      endTime: { hours: 19, minutes: 59, seconds: 59 },
    },
    {
      index: 5,
      interval: '20.00 - 00.00',
      startTime: { hours: 20, minutes: 0, seconds: 0 },
      endTime: { hours: 23, minutes: 59, seconds: 59 },
    },
  ];
  public brigadeAssignDataDefault = cloneDeep(this.brigadeAssignData);

  @ViewChild('filterAssignWrapper')
  filterAssignWrapper: ElementRef;
  @ViewChild('filterAssignContainer')
  filterAssignContainer: ElementRef;

  @ViewChild(TicketsMatrixComponent)
  ticketsMatrixComponent: TicketsMatrixComponent;

  @HostListener('window:scroll.out-zone', []) // notice out-zone
  onWindowScroll() {
    if (this.ticketsCurrentFilter.mode !== 'matrix') {
      return;
    }
    const fixedBlockWidth = this.filterAssignWrapper.nativeElement.offsetWidth;
    const topCoords = this.filterAssignWrapper.nativeElement.getBoundingClientRect().top;

    if (topCoords <= 0) {
      this.filterAssignContainer.nativeElement.style.width = fixedBlockWidth + 'px';
      this.filterAssignContainer.nativeElement.classList.add('filter-assign__container--fixed');
    } else {
      this.filterAssignContainer.nativeElement.style.width = 'auto';
      this.filterAssignContainer.nativeElement.classList.remove('filter-assign__container--fixed');
    }
    //
  }

  private getMode() {
    if (this.authService.isGRSUser()) {
      return 'table';
    }

    return this.ticketsPage ? 'matrix' : 'map';
  }

  isGRSUser(): boolean {
    return this.authService.isGRSUser();
  }

  get ticketsPage(): boolean {
    return this.route.snapshot.data.navigateTo.includes(WORK_SHIFT_PATHS.work_shift_tickets);
  }

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private ticketsAssignService: TicketsAssignService,
    private ticketViewService: TicketViewService,
    private authService: AuthService,
    private ticketsService: TicketsService,
    private modalService: NgbModal
  ) {}

  public ngOnInit() {
    this.bindFilterSyncMethods();
    this.subscribeParentRoute();
    this.subscribeChildRouter();
  }

  /**
   * Привязывает методы синхронизации к объекту фильтра
   * Вызывается каждый раз после пересоздания ticketsPeriodFilter
   */
  private bindFilterSyncMethods(): void {
    this.ticketsPeriodFilter.syncGPSubtypesBasedOnTypes = () => {
      this.syncGPSubtypesBasedOnTypes();
    };
    this.ticketsPeriodFilter.syncResponsibleUsersBasedOnGroups = () => {
      this.syncResponsibleUsersBasedOnGroups();
    };
  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
  }

  public canDeactivate(): any {
    return new Promise((resolve) => {
      if (this.brigadeAssignData.brigades && this.brigadeAssignData.brigades.length) {
        this.onAssignedConfirmDialog().result.then(
          () => {
            this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);
            resolve(true);
          },
          () => {
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  }

  private subscribeParentRoute(): void {
    this.route.data.pipe(takeUntil(this._destroyed$)).subscribe((data) => {
      if (isDevMode()) {
        console.log('~~~~ОБНОВЛЕНИЕ СЕКТОРА~~~~ =>', data.sectorId);
      }

      this.parentParams.sectorSelected = {
        sector_id: data.sectorId || null,
      };
    });
  }

  private subscribeChildRouter(): void {
    const self = this;

    this.route.params.pipe(takeUntil(this._destroyed$)).subscribe((params: any) => {
      if (isDevMode()) {
        console.log('~~~~ИЗМЕНЕНИЯ В ДОЧЕРНЕМ СОСТОЯНИИ~~~~');
      }

      let countParameters = 0;
      let countExistsParameters = 0;

      each(self.childParams, function (value, key) {
        countParameters++;

        if (has(params, [key])) {
          countExistsParameters++;
        }
      });

      forEach(self.childParams, (value, key) => {
        self.childParams[key] = value;
      });

      this.ticketsPeriodFilter = cloneDeep(this.ticketsPeriodFilterDefault);
      this.bindFilterSyncMethods(); // Перепривязываем методы после пересоздания объекта
      this.ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilterDefault);
      this.ticketsMultipleAssign = cloneDeep(this.ticketsMultipleAssignDefault);
      this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);

      if (countParameters === countExistsParameters && this.hasValidPeriodDates(params)) {
        if (isDevMode()) {
          console.log('~~~~ПОЛНОЕ ОБНОВЛЕНИЕ И ПОЛУЧЕНИЕ ЗАЯВОК~~~~');
        }

        const ticketsTypesIds = params.tickets_types_ids.split(',');
        const filteredTypesIds = this.authService.isGRSUser() ? '7' : ticketsTypesIds.filter((id) => id !== '7');
        this.childParams = cloneDeep(params);
        self.getPeriodFilterData(self.parentParams.sectorSelected.sector_id);

        this.navigate(
          {
            ...params,
            tickets_types_ids: filteredTypesIds,
          },
          false
        );
      } else {
        if (isDevMode()) {
          console.log('~~~~СМЕНА РОУТИНГА~~~~');
        }

        self.navigateWithReplaceParams(Object.assign(this.childParams, params));
      }
    });
  }

  private getStatusesMultiData(): Observable<any> {
    const params = {
      role: this.isGRS ? SectorRole.GRRS : SectorRole.MT,
    };

    return new Observable((observer) => {
      this.ticketsAssignService.getTicketsMultipleStatuses(params).subscribe((response) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  private navigateWithReplaceParams(params) {
    const ps = cloneDeep(params);
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const pF = this.ticketsPeriodFilter;

    if (this.authService.isGRSUser()) {
      ps.tickets_types_ids = '7';
    }

    if (!this.hasValidPeriodDates(ps)) {
      ps.int_begin = this.moment(pF.dateRange.startDate.currentDate).format(this.dateFullFormat);
      ps.int_end = this.moment(pF.dateRange.endDate.currentDate).format(this.dateFullFormat);
    } else {
      ps.int_begin = this.moment(ps.int_begin).format(this.dateFullFormat);
      ps.int_end = this.moment(ps.int_end).format(this.dateFullFormat);
      this.initDates(pF);
    }

    if (ticketsPeriodFilterData.ticketsHdStatuses && ticketsPeriodFilterData.ticketsVkStatuses) {
      this.setDefaultStatuses(ps);
    }

    if (!ticketsPeriodFilterData.ticketsHdStatuses && !ticketsPeriodFilterData.ticketsVkStatuses) {
      this.loading = true;
      this.getStatusesMultiData().subscribe((response) => {
        ticketsPeriodFilterData.ticketsHdStatuses = response[0]['data'];
        ticketsPeriodFilterData.ticketsVkStatuses = response[1]['data'];

        const hdStatuses = ticketsPeriodFilterData.ticketsHdStatuses.map((s) => s.id);
        const vkStatuses = ticketsPeriodFilterData.ticketsVkStatuses.map((s) => s.id);

        ps.ticket_status = vkStatuses.join(',');
        ps.hd_ticket_status_group = hdStatuses.join(',');

        this.navigate(ps, true);
      });
    } else {
      this.navigate(ps, false);
    }
  }

  private navigate(params, isReplace): Promise<boolean> {
    const navigateTo = [WORK_SHIFT_PATHS.work_shift, WORK_SHIFT_PATHS.work_shift_s, this.parentParams.sectorSelected.sector_id]
      .concat(this.route.snapshot.data.navigateTo)
      .concat(params);

    return this.router.navigate(navigateTo, { replaceUrl: isReplace });
  }

  private hasValidPeriodDates(params): boolean {
    return !!params.int_begin && !!params.int_end && this.moment(params.int_begin).isValid() && this.moment(params.int_end).isValid();
  }

  private setDefaultStatuses(params): void {
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;

    if (!params.ticket_status && ticketsPeriodFilterData.ticketsVkStatuses) {
      params.ticket_status = ticketsPeriodFilterData.ticketsVkStatuses.map((s) => s.id).join(',');
    }

    if (!params.hd_ticket_status_group && ticketsPeriodFilterData.ticketsHdStatuses) {
      params.hd_ticket_status_group = ticketsPeriodFilterData.ticketsHdStatuses.map((s) => s.id).join(',');
    }
  }

  private getPeriodFilterData(sector_id): void {
    this.loading = true;
    this.ticketsAssignService
      .getPeriodFilterData({
        sector_id,
        role: this.isGRS ? SectorRole.GRRS : SectorRole.MT,
      })
      .subscribe(
        (response) => {
          const periodFilter = this.ticketsPeriodFilter;

          periodFilter.data.districts = response[0].data.map((d) => {
            d.full_name = d.city.ct_name + ' - ' + d.district_name;
            return d;
          });
          periodFilter.data.ticketsVkStatuses = response[1].data;
          periodFilter.data.ticketsHdStatuses = response[2].data;
          if (this.authService.isGRSUser()) {
            periodFilter.data.ticketsTypes = response[3].data;
          } else {
            periodFilter.data.ticketsTypes = response[3].data.filter((tt) => !tt.name.includes('ГРРС'));
          }
          periodFilter.data.brigades = response[4].data;
          this.ticketsCurrentFilter.ticketsSettings = response[5].data;
          periodFilter.data.typeGPs = response[6].data;
          periodFilter.data.subtypeGPs = response[7].data;
          periodFilter.data.allSubtypeGPs = response[7].data; // Сохраняем полный список для синхронизации
          periodFilter.data.responsibleGroups = response[8].data;
          periodFilter.data.responsibleUsers = response[9].data;
          periodFilter.data.allResponsibleUsers = response[9].data; // Сохраняем полный список для синхронизации

          this.initCurrentFilterData();
        },
        (error) => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  private makeDayAssigmentParams(): any {
    let assignDaySelected = this.ticketsCurrentFilter.assignDaySelected;

    return {
      sector_id: this.parentParams.sectorSelected.sector_id,
      int_begin: this.moment().add(assignDaySelected.countDays, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
      int_end: this.moment().add(assignDaySelected.countDays, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    };
  }

  private makeTicketsParams(): any {
    let pF = this.ticketsPeriodFilter;
    let params = cloneDeep(this.childParams);

    let s = pF.dateRange.startDate.dateObj ? pF.dateRange.startDate.dateObj.dateMillis : pF.dateRange.startDate.initDate;
    let e = pF.dateRange.endDate.dateObj ? pF.dateRange.endDate.dateObj.dateMillis : pF.dateRange.endDate.initDate;

    params.sector_id = this.parentParams.sectorSelected.sector_id;
    params.int_begin = this.moment(s).format(this.dateFullFormat);
    params.int_end = this.moment(e).format(this.dateFullFormat);
    params.districts_ids = (pF.districtsSelected && pF.districtsSelected.map((i) => i.d_id)) || '';
    params.address = pF.address || '';
    params.tickets_types_ids = pF.ticketTypesSelected ? pF.ticketTypesSelected.map((i) => i.id) : this.isGRS ? [7] : [1, 2, 3, 4, 5, 6];
    params.brigades_ids = (pF.brigadesSelected && pF.brigadesSelected.map((i) => i.id)) || '';
    params.hd_ticket_number = pF.ticketNumber || '';
    params.ticket_status = (this.ticketsPeriodFilter.ticketsVkStatusesSelected && this.ticketsPeriodFilter.ticketsVkStatusesSelected.map((i) => i.id)) || '';
    params.hd_ticket_status_group = (this.ticketsPeriodFilter.ticketHdStatusesSelected && this.ticketsPeriodFilter.ticketHdStatusesSelected.map((i) => i.id)) || '';
    params.gp_types = (this.ticketsPeriodFilter.typeGPSelected && this.ticketsPeriodFilter.typeGPSelected.map((i) => i.id)) || '';
    params.gp_subtypes = (this.ticketsPeriodFilter.subtypeGPSelected && this.ticketsPeriodFilter.subtypeGPSelected.map((i) => i.id)) || '';
    params.responsible_groups = (this.ticketsPeriodFilter.responsibleGroupsSelected && this.ticketsPeriodFilter.responsibleGroupsSelected.map((i) => i.g_id)) || '';
    params.responsible_users = this.ticketsPeriodFilter.responsibleUsersSelected.map((i) => i.u_login);
    params.groups = this.isGRS ? [AuthGroupTypesEnum.ServiceEngineerGRS] : [AuthGroupTypesEnum.ServiceEngineer];

    return params;
  }

  get isGRS() {
    return this.authService.isGRSUser();
  }

  private initCurrentFilterState(): void {
    const currentFilter = this.ticketsCurrentFilter;
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const ticketsPeriodFilter = this.ticketsPeriodFilter;

    currentFilter.currentFilterTypeSelected = cloneDeep(currentFilter.currentFilterTypes.all);
    currentFilter.assignDaySelected = currentFilter.assignDaysList[0];
    ticketsPeriodFilter.address = this.childParams.address;
    ticketsPeriodFilter.ticketNumber = this.childParams.hd_ticket_number;

    this.initDates(ticketsPeriodFilter);
    this.initDistricts(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initVkStatuses(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initHdStatuses(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initGPTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initGPSubTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initResponsibleGroups(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initResponsibleUsers(ticketsPeriodFilter, ticketsPeriodFilterData);
    // после первичной инициализации синхронизируем зависимые списки, чтобы UI сразу отобразил актуальные элементы
    this.syncGPSubtypesBasedOnTypes();
    this.syncResponsibleUsersBasedOnGroups();
    this.initTicketTypes(ticketsPeriodFilter, ticketsPeriodFilterData);
    this.initBrigades(ticketsPeriodFilter, ticketsPeriodFilterData);
  }

  private initCurrentFilterData(): void {
    this.initCurrentFilterState();
    this.getBrigadesAndTickets();
  }

  private initDates(ticketsPeriodFilter): void {
    ticketsPeriodFilter.dateRange.startDate.initDate = this.moment(this.childParams.int_begin)._d;
    ticketsPeriodFilter.dateRange.endDate.initDate = this.moment(this.childParams.int_end)._d;
  }

  private initDistricts(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.districts_ids) {
      const arr = this.childParams.districts_ids.split(',');
      const districts = [];

      each(ticketsPeriodFilterData.districts, (district) => {
        if (arr.indexOf(district.d_id + '') > -1) {
          districts.push(district);
        }
      });

      ticketsPeriodFilter.districtsSelected = districts;
    }
  }

  private initVkStatuses(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.ticket_status) {
      const arr = this.childParams.ticket_status.split(',');
      const statuses = [];

      each(ticketsPeriodFilterData.ticketsVkStatuses, (status) => {
        if (arr.indexOf(status.id + '') > -1) {
          statuses.push(status);
        }
      });

      ticketsPeriodFilter.ticketsVkStatusesSelected = statuses;
    }
  }

  private initHdStatuses(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.hd_ticket_status_group) {
      const arr = this.childParams.hd_ticket_status_group.split(',');
      const statuses = [];

      each(ticketsPeriodFilterData.ticketsHdStatuses, (status) => {
        if (arr.indexOf(status.id + '') > -1) {
          statuses.push(status);
        }
      });

      ticketsPeriodFilter.ticketHdStatusesSelected = statuses;
    }
  }

  private initGPTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const types = [];

    if (this.childParams.gp_types) {
      const arr = this.childParams.gp_types.split(',');

      each(ticketsPeriodFilterData.typeGPs, (typeGP) => {
        if (arr.indexOf(typeGP.id + '') > -1) {
          types.push(typeGP);
        }
      });
    }

    ticketsPeriodFilter.typeGPSelected = types;

    const appliedTypeGPs = cloneDeep(types.length ? types : ticketsPeriodFilterData.typeGPs);
    ticketsPeriodFilter.appliedTypeGPs = appliedTypeGPs.map((t) => ({
      ...t,
      selected: true,
    }));
  }

  private initGPSubTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const types = [];

    if (this.childParams.gp_subtypes) {
      const arr = this.childParams.gp_subtypes.split(',');

      each(ticketsPeriodFilterData.subtypeGPs, (typeGP) => {
        if (arr.indexOf(typeGP.id + '') > -1) {
          types.push(typeGP);
        }
      });
    }

    ticketsPeriodFilter.subtypeGPSelected = types;
    ticketsPeriodFilter.appliedSubtypeGPSelected = types;
    ticketsPeriodFilter.appliedSubtypeGPs = cloneDeep(types.length ? types : ticketsPeriodFilterData.subtypeGPs);
  }

  private initResponsibleGroups(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const groups = [];

    if (this.childParams.responsible_groups) {
      const arr = this.childParams.responsible_groups.split(',');

      each(ticketsPeriodFilterData.responsibleGroups, (group) => {
        if (arr.indexOf(group.g_id + '') > -1) {
          groups.push(group);
        }
      });
    }

    ticketsPeriodFilter.responsibleGroupsSelected = groups;
  }

  private initResponsibleUsers(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    const users = [];

    if (this.childParams.responsible_users) {
      const arr = this.childParams.responsible_users.split(',');

      each(ticketsPeriodFilterData.responsibleUsers, (user) => {
        if (arr.indexOf(user.u_login + '') > -1) {
          users.push(user);
        }
      });
    }

    ticketsPeriodFilter.responsibleUsersSelected = users;
  }

  /**
   * Синхронизирует подтипы ГП на основе выбранных типов ГП
   */
  private syncGPSubtypesBasedOnTypes(): void {
    const selectedTypes = this.ticketsPeriodFilter.typeGPSelected;
    const allSubtypes = this.ticketsPeriodFilter.data.allSubtypeGPs || this.ticketsPeriodFilter.data.subtypeGPs;

    if (!selectedTypes || selectedTypes.length === 0) {
      // Если ничего не выбрано - показываем все подтипы (создаём новые массивы для OnPush)
      this.ticketsPeriodFilter.data.subtypeGPs = [...allSubtypes];
      this.ticketsPeriodFilter.appliedSubtypeGPs = cloneDeep(allSubtypes);
      this.ticketsPeriodFilter.data = { ...this.ticketsPeriodFilter.data };
      this.cdr.detectChanges();
      return;
    }

    // Собираем флаги для фильтрации
    const filterFlags = {
      is_connection: selectedTypes.some((type: ITicketType) => type.id === 14), // Подключение
      is_accident: selectedTypes.some((type: ITicketType) => type.id === 15), // Авария
      is_resources: selectedTypes.some((type: ITicketType) => type.id === 17), // Ресурс
      is_information: selectedTypes.some((type: ITicketType) => type.id === 18), // Информация
    };

    // Фильтруем подтипы ГП на основе выбранных типов
    const filteredSubtypes = allSubtypes.filter((subtype: IGlobalProblemSubtype) => {
      const isConnection = Number(subtype.is_connection) === 1;
      const isAccident = Number(subtype.is_accident) === 1;
      const isResources = Number(subtype.is_resources) === 1;
      const isInformation = Number(subtype.is_information) === 1;

      return (
        (filterFlags.is_connection && isConnection) ||
        (filterFlags.is_accident && isAccident) ||
        (filterFlags.is_resources && isResources) ||
        (filterFlags.is_information && isInformation)
      );
    });

    // Обновляем доступные подтипы ГП (создаём новые массивы для OnPush компонентов)
    this.ticketsPeriodFilter.data.subtypeGPs = [...filteredSubtypes];
    this.ticketsPeriodFilter.appliedSubtypeGPs = cloneDeep(filteredSubtypes);

    // Принудительно обновляем ссылку на объект data для OnPush
    this.ticketsPeriodFilter.data = { ...this.ticketsPeriodFilter.data };
    this.cdr.detectChanges();

    // Очищаем выбранные подтипы, которые больше не доступны
    if (this.ticketsPeriodFilter.subtypeGPSelected) {
      this.ticketsPeriodFilter.subtypeGPSelected = this.ticketsPeriodFilter.subtypeGPSelected.filter((selectedSubtype) =>
        filteredSubtypes.some((subtype) => subtype.id === selectedSubtype.id)
      );
    }
  }

  /**
   * Синхронизирует ответственных пользователей на основе выбранных групп
   */
  private syncResponsibleUsersBasedOnGroups(): void {
    const selectedGroups = this.ticketsPeriodFilter.responsibleGroupsSelected;
    const allUsers = this.ticketsPeriodFilter.data.allResponsibleUsers || this.ticketsPeriodFilter.data.responsibleUsers;

    if (!selectedGroups || selectedGroups.length === 0) {
      // Если ничего не выбрано - показываем всех пользователей (создаём новый массив для OnPush)
      this.ticketsPeriodFilter.data.responsibleUsers = [...allUsers];
      this.ticketsPeriodFilter.data = { ...this.ticketsPeriodFilter.data };
      this.cdr.detectChanges();
      return;
    }

    // Получаем список ID выбранных групп
    const selectedGroupIds = selectedGroups.map((group) => Number(group.g_id));

    // Фильтруем пользователей по выбранным группам
    const filteredUsers = allUsers.filter((user) => {
      return selectedGroupIds.includes(Number(user.u_group));
    });

    // Обновляем доступных ответственных пользователей (создаём новый массив для OnPush)
    this.ticketsPeriodFilter.data.responsibleUsers = [...filteredUsers];

    // Принудительно обновляем ссылку на объект data для OnPush
    this.ticketsPeriodFilter.data = { ...this.ticketsPeriodFilter.data };
    this.cdr.detectChanges();

    // Очищаем выбранных пользователей, которые больше не доступны
    if (this.ticketsPeriodFilter.responsibleUsersSelected) {
      this.ticketsPeriodFilter.responsibleUsersSelected = this.ticketsPeriodFilter.responsibleUsersSelected.filter((selectedUser) =>
        filteredUsers.some((user) => user.u_login === selectedUser.u_login)
      );
    }
  }

  private initTicketTypes(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.tickets_types_ids) {
      const arr = this.childParams.tickets_types_ids.split(',');
      const types = [];

      each(ticketsPeriodFilterData.ticketsTypes, (type) => {
        if (arr.indexOf(type.id + '') > -1) {
          types.push(type);
        }
      });

      ticketsPeriodFilter.ticketTypesSelected = types;
    }
  }

  private initBrigades(ticketsPeriodFilter, ticketsPeriodFilterData): void {
    if (this.childParams.brigades_ids) {
      const arr = this.childParams.brigades_ids.split(',');
      const brigades = [];

      each(ticketsPeriodFilterData.brigades, (brigade) => {
        if (arr.indexOf(brigade.id + '') > -1) {
          brigades.push(brigade);
        }
      });

      ticketsPeriodFilter.brigadesSelected = brigades;
    }
  }

  private getBrigadesForDayAssigment(params): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ticketsAssignService.getBrigades(params).subscribe(
        (response) => {
          this.ticketsMultipleAssign.brigades = response.data.map((b) => {
            b.tickets_count = b.tickets_count || 0;
            return b;
          });
          this.changeBrigadesName();
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  private getTickets(params): Promise<any> {
    return new Promise((resolve, reject) => {
      this.ticketsAssignService.getTickets(params).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  private getBrigadesAndTickets(): void {
    const brigades = this.getBrigadesForDayAssigment(this.makeDayAssigmentParams());
    const tickets = this.getTickets(this.makeTicketsParams());
    let timerId = null;

    this.tickets.ticketsLoading = true;
    this.tickets.data = null;
    this.tickets.dataFlatList = null;
    this.tickets.dataMatrix = null;
    this.tickets.dataTable = null;

    Promise.all([brigades, tickets]).then(
      (response) => {
        this.ticketsMultipleAssign.brigades = null;

        this.ticketsMultipleAssign.brigades = response[0].data;
        this.tickets = {
          ...this.tickets,
          data: response[1].data,
        };

        this.resetTicketStatus();
        this.makeTicketsFormat();
        this.changeBrigadesName();
        this.recalculate();

        this.loading = false;
        this.tickets.ticketsLoading = false;

        timerId = setTimeout(() => {
          if (timerId) {
            clearTimeout(timerId);
          }

          if (this.ticketsMatrixComponent) {
            this.ticketsMatrixComponent.setEllipsis();
          }
        });
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.tickets.ticketsLoading = false;
      }
    );
  }

  private getTicketsLineInfo() {
    const tickets = this.getTicketsForLineInfo();

    this.ticketViewService.getHdAbonentStatus({ abon_info: tickets }).subscribe(
      (response) => {
        this.setLineInfoToTickets(response.data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private getTicketsForLineInfo() {
    const tickets = [];
    const ticketTypes = [1, 2, 3];

    each(this.tickets.dataFlatList, (ticket) => {
      if (ticketTypes.indexOf(ticket.ticket_type.id) > -1) {
        tickets.push({
          ticket_id: ticket.id,
          login: ticket.ticket_login || '',
        });
      }
    });

    return tickets;
  }

  private setLineInfoToTickets(tickets) {
    const dataFlatList = this.tickets.dataFlatList;
    each(tickets, (ticket) => {
      const index = findIndex(dataFlatList, (t: any) => t.id === ticket.ticket_id);

      if (index > -1) {
        dataFlatList[index].hd_line_status_info = this.mapNetworkStatus(ticket.code);
      }
    });
  }

  private mapNetworkStatus(code: number | null | undefined): number | null {
    if (code == null) {
      return null;
    }
    if ([1, 2, 3, 4].indexOf(code) > -1) {
      return 1;
    }
    return 0;
  }

  private resetTicketStatus(): void {
    const statuses = this.ticketsCurrentFilter.currentFilterTypes;

    statuses.assigned.counts = 0;
    statuses.unassigned.counts = 0;
    statuses.needActions.counts = 0;
    statuses.opened.counts = 0;
    statuses.all.counts = 0;
  }

  private makeTicketsFormat(): void {
    this.tickets.dataTable = [];

    each(this.tickets.data, (date) => {
      date.isShow = true;
      const dateInTable = this.addDateToTable(date);

      each(date.intervals, (interval) => {
        interval.isGPInterval = interval.commutator_fail_block;
        interval.isOpen = true;
        interval.ticketsCount = 0;
        interval.isShow = true;

        each(interval.districts, (district) => {
          district.isOpened = true;
          district.isShow = true;
          interval.ticketsCount += (district.tickets && district.tickets.length) || 0;

          each(district.tickets, (ticket) => {
            ticket.isChecked = false;
            ticket.isShow = true;
            ticket.district_name = ticket.district.district_name;
            ticket.brigade_default = cloneDeep(ticket.brigade);
            ticket.hd_line_status_info = this.mapNetworkStatus(ticket.extra_flags && ticket.extra_flags.network_status);

            this.addTicketToFlatList(ticket);
            this.countTicketOnBrigade(ticket);
            this.addTicketToMatrixList(date.date, ticket);
            this.addTicketToTable(dateInTable, interval, district, ticket);
          });
        });
      });
    });

    this.sortingMatrixList();
    this.sortingLineList();
  }

  private addDateToTable(date) {
    if (!this.tickets.dataTable) {
      this.tickets.dataTable = [];
    }

    const newDate = {
      date: date.date,
      intervals: [],
      gp_intervals: [],
      edo_intervals: [],
      isShow: true,
    };

    this.tickets.dataTable.push(newDate);
    return newDate;
  }

  /**
   * Добавляет в структуру таблицы в указанную дату заявку.
   *  - если интервала еще не было, добавит интервал
   *  - если в интервале не было дистрикта, добавит дистрикт.
   * Т.о. заявки разных групп могут быть в разных интервалах и дистриктах.
   *
   * @param dateTable
   * @param interval
   * @param district
   * @param ticket
   */
  private addTicketToTable(dateTable, interval, district, ticket) {
    const isGPIntervalTicket = this.ticketsService.checkGPInterval(ticket.hd_schedule_intbegin, ticket.hd_schedule_intend);

    // выбор списка интервалов
    let tableIntervals = dateTable.intervals; // помойка заявок
    if (isGPIntervalTicket) {
      // авария
      tableIntervals = dateTable.gp_intervals;
    } else if (ticket.ticket_type.id === 5) {
      // исправление договора
      tableIntervals = dateTable.edo_intervals;
    }

    // поиск интервала
    // для заявок "исправление договора" считаем один условный интервал
    // (т.е. визуально отображать в одном интервале)
    let tableInterval;
    if (ticket.ticket_type.id !== 5) {
      tableInterval = find(tableIntervals, (intrv) => {
        return intrv.int_begin === interval.int_begin && intrv.int_end === interval.int_end;
      });
    } else {
      tableInterval = tableIntervals[0];
    }

    if (!tableInterval) {
      let int_begin = interval.int_begin;
      let int_end = interval.int_end;
      if (ticket.ticket_type === 5) {
        int_begin = null;
        int_end = null;
      }
      tableInterval = {
        int_begin: int_begin,
        int_end: int_end,
        districts: [],
        isOpen: true,
        isShow: true,
        ticketsCount: 0,
      };

      tableIntervals.push(tableInterval);
    }

    tableInterval.ticketsCount++;

    // поиск района
    let tableDistrict: any = find(tableInterval.districts, {
      district_name: district.district_name,
    });

    if (!tableDistrict) {
      tableDistrict = {
        city_name: district.city_name,
        district_name: district.district_name,
        tickets: [],
        isOpened: true,
        isShow: true,
        all: 0,
        assigned: 0,
      };

      tableInterval.districts.push(tableDistrict);
    }

    // добавление заявки в район
    tableDistrict.tickets.push(ticket);
    tableDistrict.all++;
    if (ticket.brigade) {
      tableDistrict.assigned++;
    }
  }

  private recalculateStatusAndTickets(isVisibleFn: (ticket) => boolean = identity): void {
    each(this.tickets.data, (date) => {
      each(date.intervals, (interval) => {
        each(interval.districts, (district) => {
          each(district.tickets, (ticket) => {
            if (isVisibleFn(ticket)) {
              this.countTicketStatus(ticket);
              this.countTicketOnBrigade(ticket);
            }
          });
        });
      });
    });
  }

  private filteringTicketsByStatus(): void {
    this.filteringListByStatus();
    this.filteringMatrixByStatus();
  }

  private filteringListByStatus() {
    let isExistOneVisibleInterval = false;
    let isExistOneVisibleDistrict = false;
    let isExistOneVisibleTicket = false;

    each(this.tickets.data, (date) => {
      isExistOneVisibleInterval = false;

      each(date.intervals, (interval) => {
        isExistOneVisibleDistrict = false;

        each(interval.districts, (district) => {
          isExistOneVisibleTicket = false;

          each(district.tickets, (ticket) => {
            ticket.isShow = this.checkShowTicket(ticket);

            if (ticket.isShow) {
              isExistOneVisibleTicket = true;
            }
          });

          district.isShow = isExistOneVisibleTicket;

          if (isExistOneVisibleTicket) {
            isExistOneVisibleDistrict = true;
          }
        });

        interval.isShow = isExistOneVisibleDistrict;

        if (isExistOneVisibleDistrict) {
          isExistOneVisibleInterval = true;
        }
      });

      date.isShow = isExistOneVisibleInterval;
    });
  }

  private filteringMatrixByStatus() {
    let isExistOneVisibleGPIntervalTicket = false;
    let isExistOneVisibleInterval = false;
    let isExistOneVisibleTicket = false;

    each(this.tickets.dataMatrix, (date) => {
      isExistOneVisibleInterval = false;
      isExistOneVisibleGPIntervalTicket = false;

      each(date.gp_intervals.tickets, (ticket) => {
        ticket.isShow = this.checkShowTicket(ticket);

        if (ticket.isShow) {
          isExistOneVisibleGPIntervalTicket = true;
        }
      });

      date.gp_intervals.isShow = isExistOneVisibleGPIntervalTicket;

      each(date.intervals.intervals, (interval) => {
        isExistOneVisibleTicket = false;

        each(interval.tickets, (ticket) => {
          ticket.isShow = this.checkShowTicket(ticket);

          if (ticket.isShow) {
            isExistOneVisibleTicket = true;
          }
        });

        interval.isShow = isExistOneVisibleTicket;

        if (isExistOneVisibleTicket) {
          isExistOneVisibleInterval = true;
        }
      });

      date.isShow = isExistOneVisibleInterval;
    });
  }

  private checkShowTicket(ticket): boolean {
    const currentFilterTypeSelected = this.ticketsCurrentFilter.currentFilterTypeSelected;
    const statuses = this.ticketsCurrentFilter.currentFilterTypeSelected.ticketStatuses;

    if (currentFilterTypeSelected.id === 'opened') {
      const isShowByStatusTicket = statuses.indexOf(ticket.hd_ticket_status.id) > -1;
      return isShowByStatusTicket;
    }

    if (currentFilterTypeSelected.id === 'assigned') {
      const brigadeIndex = findIndex(this.brigadeAssignData.brigades, (b) => b.ticket_id === ticket.id);
      const isShowByStatusTicket = statuses.indexOf(ticket.ticket_status.id) > -1;
      const isShowByAssignedTicket = brigadeIndex > -1 ? !!this.brigadeAssignData.brigades[brigadeIndex].brigade_id : false;

      return isShowByStatusTicket || isShowByAssignedTicket;
    }

    if (currentFilterTypeSelected.id === 'unassigned') {
      const brigadeIndex = findIndex(this.brigadeAssignData.brigades, (b) => b.ticket_id === ticket.id);
      const isShowByStatusTicket = this.isGRS
        ? (!ticket.departures || ticket.departures.length === 0) && ticket.hd_ticket_status.id === 14
        : statuses.indexOf(ticket.ticket_status.id) > -1;
      const isShowByAssignedTicket = brigadeIndex > -1 ? !!!this.brigadeAssignData.brigades[brigadeIndex].bridage_id : false;

      if (isShowByStatusTicket && isShowByAssignedTicket) {
        return false;
      } else if (isShowByStatusTicket && !isShowByAssignedTicket) {
        return true;
      }
    }

    if (currentFilterTypeSelected.id === 'needActions') {
      return statuses.indexOf(ticket.ticket_status.id) > -1;
    }

    if (currentFilterTypeSelected.id === 'all') {
      return true;
    }
  }

  private addTicketToFlatList(ticket: any): void {
    if (!this.tickets.dataFlatList) {
      this.tickets.dataFlatList = [];
    }

    this.tickets.dataFlatList.push(ticket);
  }

  private countTicketStatus(ticket): void {
    const currentFilterTypes = this.ticketsCurrentFilter.currentFilterTypes;

    if (currentFilterTypes.opened.ticketStatuses.indexOf(ticket.hd_ticket_status.id) > -1) {
      currentFilterTypes.opened.counts++;
    }

    if (currentFilterTypes.assigned.ticketStatuses.indexOf(ticket.ticket_status.id) > -1) {
      currentFilterTypes.assigned.counts++;
    }

    const isUnassigned = this.isGRS
      ? (!ticket.departures || ticket.departures.length === 0) && ticket.hd_ticket_status.id === 14
      : currentFilterTypes.unassigned.ticketStatuses.indexOf(ticket.ticket_status.id) > -1;

    if (isUnassigned) {
      currentFilterTypes.unassigned.counts++;
    }

    if (currentFilterTypes.needActions.ticketStatuses.indexOf(ticket.ticket_status.id) > -1) {
      currentFilterTypes.needActions.counts++;
    }

    currentFilterTypes.all.counts++;
  }

  private countTicketOnBrigade(ticket): void {
    const brigades = this.ticketsMultipleAssign.brigades;
    const assignDayMillis = this.moment().add(this.ticketsCurrentFilter.assignDaySelected.countDays, 'day').startOf('day').valueOf();
    const endDayMillis = this.moment()
      .add(this.ticketsCurrentFilter.assignDaySelected.countDays + this.ticketsCurrentFilter.ticketsSettings.days_for_assignment, 'day')
      .endOf('day')
      .valueOf();
    const ticketMillis = +new Date(ticket.hd_schedule_date);

    if (((ticket.brigade && ticket.brigade.id) || (ticket.brigade && ticket.brigade_id)) && ticketMillis >= assignDayMillis && ticketMillis <= endDayMillis) {
      const brigadeIndex = findIndex(brigades, (b: any) => b.id === ticket.brigade.id);

      if (brigadeIndex > -1) {
        brigades[brigadeIndex].tickets_count += 1;
      }
    }
  }

  private getTicketInterval(date): any {
    const intervals = this.intervals;
    let interval = null;

    each(intervals, (int: any) => {
      const ticketDate = this.moment(date);
      const ticketDateMillis = ticketDate.hours() * 60 * 60 + ticketDate.minutes() * 60 + ticketDate.millisecond();
      const startDateMillis = int.startTime.hours * 60 * 60 + int.startTime.minutes * 60 + int.startTime.seconds;
      const endDateMillis = int.endTime.hours * 60 * 60 + int.endTime.minutes * 60 + int.endTime.seconds;

      if (ticketDateMillis >= startDateMillis && ticketDateMillis <= endDateMillis) {
        interval = { index: int.index, interval: int.interval };
      }
    });

    return interval;
  }

  private makeIntervals(): any[] {
    let intervals = [];

    each(this.intervals, (interval) => {
      intervals.push({ interval: interval.interval, tickets: [] });
    });

    return intervals;
  }

  private addTicketToMatrixList(date, ticket): void {
    let ticketsOnDate = this.tickets;
    let dateIndex;
    const interval = this.getTicketInterval(ticket.hd_schedule_intbegin);
    const isGPIntervalTicket = this.ticketsService.checkGPInterval(ticket.hd_schedule_intbegin, ticket.hd_schedule_intend);

    if (!ticketsOnDate.dataMatrix) {
      ticketsOnDate.dataMatrix = [];
    }

    dateIndex = findIndex(ticketsOnDate.dataMatrix, (i: any) => i.date === date);

    if (dateIndex === -1) {
      ticketsOnDate.dataMatrix.push({
        date,
        gp_intervals: { isShow: true, isOpen: true, tickets: [] },
        edo_intervals: { isShow: true, isOpen: true, tickets: [] },
        intervals: { isShow: true, intervals: this.makeIntervals() },
      });
    }

    dateIndex = findIndex(ticketsOnDate.dataMatrix, (i: any) => i.date === date);

    if (ticket.ticket_type.id === 5) {
      if (this.ticketsCurrentFilter.ticketsSettings.days_alert_to_correct_contract) {
        // если до конца интервала меньше дней чем days_alert_to_correct_contract
        // то интервал надо подсветить
        const startDate = this.moment(ticket.hd_schedule_intend, 'YYYY-MM-DDThh:mm:ss');
        const endDate = this.moment(this.ticketsCurrentFilter.ticketsSettings.sys_date, 'YYYY-MM-DDThh:mm:ss');
        const diff = this.moment(startDate).diff(endDate);
        const diffDays = this.moment.duration(diff).asDays();

        ticket.isWarnExpDays = diffDays < this.ticketsCurrentFilter.ticketsSettings.days_alert_to_correct_contract;
      }

      ticketsOnDate.dataMatrix[dateIndex].edo_intervals.tickets.push(ticket);
    } else if (isGPIntervalTicket) {
      ticketsOnDate.dataMatrix[dateIndex].gp_intervals.tickets.push(ticket);
    } else {
      ticketsOnDate.dataMatrix[dateIndex].intervals.intervals[interval.index].tickets.push(ticket);
    }
  }

  private sortingMatrixList(): void {
    let tickets = this.tickets;

    each(tickets.dataMatrix, (date) => {
      date.gp_intervals.tickets = orderBy(date.gp_intervals.tickets, ['district_name', 'hd_schedule_intbegin', 'hd_ticket_number'], ['asc', 'asc', 'asc']);
      each(date.gp_intervals.tickets, (ticket: any, index: number) => {
        if (index + 1 > 6) {
          let idx = (index + 1) % 6;
          ticket._index = idx === 0 ? 6 : idx;
        } else {
          ticket._index = index + 1;
        }
      });

      date.edo_intervals.tickets = orderBy(date.edo_intervals.tickets, ['hd_schedule_intbegin'], ['asc']);
      each(date.edo_intervals.tickets, (ticket: any, index: number) => {
        if (index + 1 > 6) {
          let idx = (index + 1) % 6;
          ticket._index = idx === 0 ? 6 : idx;
        } else {
          ticket._index = index + 1;
        }
      });

      each(date.intervals.intervals, (interval) => {
        interval.tickets = orderBy(interval.tickets, ['district_name', 'hd_schedule_intbegin', 'hd_ticket_number'], ['asc', 'asc', 'asc']);
      });
    });

    tickets.dataMatrix = orderBy(tickets.dataMatrix, ['date'], ['asc']);
  }

  private sortingLineList(): void {
    each(this.tickets.data, (date) => {
      each(date.intervals, (interval) => {
        each(interval.districts, (district) => {
          district.tickets = orderBy(district.tickets, ['hd_ticket_number'], ['asc']);
        });
      });
    });
  }

  private changeBrigadesName(): void {
    each(this.ticketsMultipleAssign.brigades, (b) => {
      b.brigade_name_merged = b.brigade_name + (b.tickets_count > 0 ? '(' + b.tickets_count + ')' : '');
    });
  }

  public applyPeriodFilter() {
    if (isDevMode()) {
      console.log('APPLY FILTER ~~~~~~~~~~~~', this);
    }

    let params = cloneDeep(this.makeTicketsParams());
    let oldParams = cloneDeep(this.childParams);
    params.ticket_status = (params.ticket_status && params.ticket_status.join(',')) || '';
    params.hd_ticket_status_group = (params.hd_ticket_status_group && params.hd_ticket_status_group.join(',')) || '';
    params.districts_ids = (params.districts_ids && params.districts_ids.join(',')) || '';
    params.tickets_types_ids = (params.tickets_types_ids && params.tickets_types_ids.join(',')) || '';
    params.brigades_ids = (params.brigades_ids && params.brigades_ids.join(',')) || '';
    params.gp_types = (params.gp_types && params.gp_types.join(',')) || '';
    params.gp_subtypes = (params.gp_subtypes && params.gp_subtypes.join(',')) || '';
    params.responsible_groups = (params.responsible_groups && params.responsible_groups.join(',')) || '';
    params.responsible_users = (params.responsible_users && params.responsible_users.join(',')) || '';

    if (isEqual(oldParams, params)) {
      if (isDevMode()) {
        console.log('~~~~ПАРАМЕТРЫ НЕ ОТЛИЧАЮТСЯ, НУЖНО ПУЛУЧАТЬ ДАННЫЕ~~~~');
      }

      this.canDeactivate().then((res) => {
        if (res) {
          this.getBrigadesAndTickets();
        }
      });
    } else {
      if (isDevMode()) {
        console.log('~~~~ПАРАМЕТРЫ ОТЛИЧАЮТСЯ, НУЖНО СДЕЛАТЬ РЕДИРЕКТ~~~~');
      }

      this.navigate(params, false);
    }
  }

  public resetPeriodFilter() {
    if (isDevMode()) {
      console.log('RESET FILTER ~~~~~~~~~~~~', this);
      console.log('~~~~ПАРАМЕТРЫ ОТЛИЧАЮТСЯ, НУЖНО СДЕЛАТЬ РЕДИРЕКТ~~~~');
    }

    const params = this.makeResetPeriodParams();

    this.resetPeriodFilterState(params);
    this.navigate(params, true).then((isNavigated) => {
      if (!isNavigated) {
        this.getBrigadesAndTickets();
      }
    });
  }

  private makeResetPeriodParams(): any {
    const params = cloneDeep(this.childParamsDefault);
    const dateRange = this.ticketsPeriodFilter.dateRange;

    params.int_begin = this.moment(dateRange.startDate.currentDate).format(this.dateFullFormat);
    params.int_end = this.moment(dateRange.endDate.currentDate).format(this.dateFullFormat);

    if (this.authService.isGRSUser()) {
      params.tickets_types_ids = '7';
    }

    this.setDefaultStatuses(params);

    return params;
  }

  private resetPeriodFilterState(params): void {
    const ticketsPeriodFilterData = this.ticketsPeriodFilter.data;
    const ticketsSettings = this.ticketsCurrentFilter.ticketsSettings;

    this.childParams = cloneDeep(params);
    this.ticketsPeriodFilter = cloneDeep(this.ticketsPeriodFilterDefault);
    this.bindFilterSyncMethods();
    this.ticketsPeriodFilter.data = ticketsPeriodFilterData;
    this.ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilterDefault);
    this.ticketsCurrentFilter.ticketsSettings = ticketsSettings;
    this.ticketsMultipleAssign = cloneDeep(this.ticketsMultipleAssignDefault);
    this.brigadeAssignData = cloneDeep(this.brigadeAssignDataDefault);

    this.initCurrentFilterState();
  }

  public exportPeriodFilter() {
    const params = this.makeTicketsParams();

    this.ticketsAssignService.downloadTickets(params).subscribe();
  }

  private checkAssignedTickets(): boolean {
    return this.brigadeAssignData.brigades && this.brigadeAssignData.brigades.length > 0;
  }

  public changeDayForAssigment(day): void {
    const ticketsCurrentFilter = cloneDeep(this.ticketsCurrentFilter);
    const currentDate = +new Date();
    const workingDateAssign = this.moment(this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time).valueOf();

    if (currentDate < workingDateAssign && day.id === 2) {
      ticketsCurrentFilter.assignDaySelected = this.ticketsCurrentFilter.assignDaysList[0];
      this.ticketsCurrentFilter = ticketsCurrentFilter;

      const alertDialog = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      alertDialog.componentInstance.title = 'Ошибка';
      alertDialog.componentInstance.description = `Назначение заявок на завтрашние бригады будет доступно<br> с
             ${this.moment(this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time).format('HH:mm')}`;
      alertDialog.componentInstance.abortButtonName = 'Закрыть';
    } else {
      ticketsCurrentFilter.assignDaySelected = day;
      this.ticketsCurrentFilter = ticketsCurrentFilter;
      this.getBrigadesForDayAssigment(this.makeDayAssigmentParams()).then(() => {
        this.onResetCheckedTickets();
        this.resetTicketStatus();
        this.recalculate();
        this.changeBrigadesName();
      });
    }
  }

  public recalculate() {
    if (this.authService.isGRSUser()) {
      this.ticketsCurrentFilter.recalculateStatusAndTickets();
    } else {
      this.recalculateStatusAndTickets();
    }
  }

  public onChangeBrigadeForAssigment(brigade): void {
    this.ticketsMultipleAssign.brigadeSelected = brigade;
  }

  public onChangeCheckedTicket(): void {
    const checkedTickets = this.tickets.dataFlatList.filter((t) => t.isChecked);

    this.ticketsMultipleAssign.ticketsChecked = checkedTickets;
    this.ticketsMultipleAssign.isExistCheckedTicket = checkedTickets.length > 0;
  }

  public onToggleMapSelectionMode(): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;

    ticketsMultipleAssign.isMapSelectionMode = !ticketsMultipleAssign.isMapSelectionMode;

    if (!ticketsMultipleAssign.isMapSelectionMode) {
      this.onResetCheckedTickets();
    }

    this.ticketsMultipleAssign = Object.assign({}, ticketsMultipleAssign);
  }

  public onToggleMapTicket(ticket): void {
    if (!this.ticketsMultipleAssign.isMapSelectionMode || !this.canAssignTicket(ticket)) {
      return;
    }

    ticket.isChecked = !ticket.isChecked;
    this.onChangeCheckedTicket();
    this.ticketsMultipleAssign = Object.assign({}, this.ticketsMultipleAssign);
  }

  public canAssignTicket(ticket): boolean {
    const ticketStatus = ticket && ticket.ticket_status;
    const hdTicketStatus = ticket && ticket.hd_ticket_status;
    const ticketVKStatus = ticketStatus && Number(ticketStatus.id);
    const ticketHDStatus = hdTicketStatus && Number(hdTicketStatus.id);

    return ticketVKStatus !== 6 && ticketVKStatus !== 8 && !(ticketHDStatus === 194 && ticketVKStatus === 12);
  }

  public hasPendingMapAssignment(ticket): boolean {
    const ticketId = ticket && ticket.id;

    return findIndex(this.brigadeAssignData.brigades, (assignment) => assignment.ticket_id === ticketId) > -1;
  }

  public cancelMapTicketAssignment(ticket): void {
    const assignmentIndex = findIndex(
      this.brigadeAssignData.brigades,
      (assignment) => assignment.ticket_id === (ticket && ticket.id)
    );

    if (!ticket || assignmentIndex < 0) {
      return;
    }

    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const currentBrigadeId = ticket.brigade && (ticket.brigade.id || ticket.brigade.brigade_id);
    const originalBrigade = ticket.brigade_default;
    const originalBrigadeId = originalBrigade && (originalBrigade.id || originalBrigade.brigade_id);
    const currentBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (brigade: any) => brigade.id === currentBrigadeId);
    const originalBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (brigade: any) => brigade.id === originalBrigadeId);

    if (currentBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[currentBrigadeIndex].tickets_count -= 1;
    }

    if (originalBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[originalBrigadeIndex].tickets_count += 1;
    }

    if (!originalBrigade) {
      this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
      this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;
    }

    this.brigadeAssignData.brigades.splice(assignmentIndex, 1);
    ticket.brigade = originalBrigade ? cloneDeep(originalBrigade) : null;
    this.changeBrigadesName();
    this.ticketsMultipleAssign = Object.assign({}, ticketsMultipleAssign);
  }

  public onAddTicketsToBrigades(): void {
    const dateFullFormat = Enums.dates.fullFormat;
    const currentFilter = this.ticketsCurrentFilter;
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const assignBrigade = ticketsMultipleAssign.brigadeSelected;
    const scheduleDate = this.moment(currentFilter.ticketsSettings.tomorrow_assignment_time)
      .add(currentFilter.assignDaySelected.countDays, 'day')
      .startOf('day')
      .format(dateFullFormat);

    each(this.ticketsMultipleAssign.ticketsChecked, (ticket) => {
      this.brigadeAssignData.addBrigade({
        ticket_id: ticket.id,
        ticket_number: ticket.hd_ticket_number,
        ticket_type: ticket.ticket_type,
        brigade_id: assignBrigade.id,
        schedule_date: scheduleDate,
        sector_id: this.parentParams.sectorSelected.sector_id,
      });

      ticket.brigade = {
        id: assignBrigade.id,
        brigade_name: assignBrigade.brigade_name,
      };
      ticket.isChecked = false;
    });

    ticketsMultipleAssign.brigadeSelected = null;
    ticketsMultipleAssign.ticketsChecked = null;
    ticketsMultipleAssign.isExistCheckedTicket = false;
    ticketsMultipleAssign.isMapSelectionMode = false;

    this.ticketsMultipleAssign = Object.assign({}, ticketsMultipleAssign);
  }

  private updateCountBrigade(ticketIndex, obj): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const ticket = this.tickets.dataFlatList[ticketIndex];
    const oldBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === ticket.brigade.id || b.id === ticket.brigade.brigade_id);
    const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

    if (oldBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
    }

    if (newBrigadeIndex > -1) {
      ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
    }
  }

  public addAssignBrigade(obj): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    let ticketIndex = findIndex(this.tickets.dataFlatList, (t: any) => t.id === obj.ticket_id);
    let index = findIndex(this.brigadeAssignData.brigades, (brigade) => brigade.ticket_id === obj.ticket_id);
    let ticket = this.tickets.dataFlatList[ticketIndex];

    this.brigadeAssignData.isAssignedSuccess = false;

    if (index > -1) {
      if (ticket && ticket.brigade_default && ticket.brigade_default.id === obj.brigade_id) {
        obj.brigade_old_id = (ticket.brigade && ticket.brigade.id) || (ticket.brigade_default && ticket.brigade_default.id);
        this.removeAssignBrigade(obj);
      } else {
        this.brigadeAssignData.brigades[index].brigade_id = obj.brigade_id;
        this.updateCountBrigade(ticketIndex, obj);
      }
    } else {
      if (ticket) {
        ticket = this.tickets.dataFlatList[ticketIndex];

        if (!ticket.brigade) {
          this.ticketsCurrentFilter.currentFilterTypes.assigned.counts += 1;
          this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts -= 1;

          const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

          if (newBrigadeIndex > -1) {
            ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
          }
        } else {
          this.updateCountBrigade(ticketIndex, obj);
        }
      }

      this.brigadeAssignData.brigades.push(obj);
    }

    this.changeBrigadesName();
  }

  public removeAssignBrigade(obj: any): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;
    const oldBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_old_id);
    let index = findIndex(this.brigadeAssignData.brigades, (brigade) => brigade.ticket_id === obj.ticket_id);
    let ticketIndex = findIndex(this.tickets.dataFlatList, (t: any) => t.id === obj.ticket_id);
    let ticket = this.tickets.dataFlatList[ticketIndex];

    this.brigadeAssignData.isAssignedSuccess = false;

    if (index > -1) {
      if (ticket && !ticket.brigade_default) {
        this.brigadeAssignData.brigades.splice(index, 1);
        ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;
        this.changeBrigadesName();
      } else if (ticket && ticket.brigade_default && ticket.brigade_default.id === obj.brigade_id) {
        const newBrigadeIndex = findIndex(ticketsMultipleAssign.brigades, (b: any) => b.id === obj.brigade_id);

        if (newBrigadeIndex > -1) {
          ticketsMultipleAssign.brigades[newBrigadeIndex].tickets_count += 1;
        }

        if (obj.brigade_id !== obj.brigade_old_id && obj.brigade_old_id) {
          ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
        }

        this.brigadeAssignData.brigades.splice(index, 1);
        this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
        this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;
        this.changeBrigadesName();
      } else {
        this.brigadeAssignData.brigades[index].brigade_id = null;
      }
    } else {
      ticketsMultipleAssign.brigades[oldBrigadeIndex].tickets_count -= 1;
      this.ticketsCurrentFilter.currentFilterTypes.assigned.counts -= 1;
      this.ticketsCurrentFilter.currentFilterTypes.unassigned.counts += 1;

      this.brigadeAssignData.brigades.push(obj);
      this.changeBrigadesName();
    }
  }

  public assignBrigades(): void {
    const brigadesAssign = cloneDeep(this.brigadeAssignData.brigades).map((brigade) => {
      delete brigade.ticket_number;
      return brigade;
    });
    this.brigadeAssignData.isAssignedLoading = true;

    let assignOrCreate$;

    if (this.authService.isGRSUser()) {
      const grsTickets = brigadesAssign.filter((assign) => assign.ticket_type.id === TicketTypesEnum.GlobalProblemGRS);

      if (!grsTickets.length) {
        return;
      }

      const groupsByBrigadeId = groupBy(grsTickets, 'brigade_id');

      assignOrCreate$ = forkJoin(
        map(groupsByBrigadeId, (tickets, brigadeId) => {
          return this.ticketsAssignService.createDeparture(
            brigadeId,
            tickets.map((t) => t.ticket_id)
          );
        })
      );
    } else {
      assignOrCreate$ = this.ticketsAssignService.assignBrigades(brigadesAssign);
    }

    assignOrCreate$.subscribe(
      () => {
        this.brigadeAssignData.isAssignedSuccess = true;
        this.brigadeAssignData.brigades = [];
        this.getBrigadesAndTickets();
        this.brigadeAssignData.isAssignedLoading = false;
      },
      (error) => {
        if (error.status === 400) {
          const errorsList = [];
          const errors = error.error.data || error.error.error;

          each(errors, (err, index) => {
            if (!isEmpty(err)) {
              const errObj = {
                ticket_number: this.brigadeAssignData.brigades[index].ticket_number,
                errors: [],
              };

              each(err, (value) => {
                if (value && isArray(value)) {
                  errObj.errors = errObj.errors.concat(value);
                }
              });

              errorsList.push(errObj);
            }
          });

          if (errorsList.length) {
            this.openBrigadeAssignErrorModal(errorsList);
          }
        }
        this.brigadeAssignData.isAssignedLoading = false;
      }
    );
  }

  private openBrigadeAssignErrorModal(errors) {
    const brigadeAssignErrorModal = this.modalService.open(TicketsAssignErrorModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper modal-wrapper--w-600',
      backdrop: 'static',
    });

    brigadeAssignErrorModal.componentInstance.errorsList = errors;
  }

  public onAssignedConfirmDialog(): NgbModalRef {
    const assignedConfirmDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    assignedConfirmDialog.componentInstance.title = 'Подтвердите обновление без сохранения';
    assignedConfirmDialog.componentInstance.description =
      'На странице есть не отправленные в работу заявки с ' +
      'назначенной бригадой. После обновления списка заявок изменения не сохранятся. Вы действительно хотите' +
      ' обновить список заявок? ';
    assignedConfirmDialog.componentInstance.successButtonName = 'Да, обновить';
    assignedConfirmDialog.componentInstance.abortButtonName = 'Отмена';

    return assignedConfirmDialog;
  }

  public changeTypeSelected(type): void {
    const currentFilter = this.ticketsCurrentFilter;

    currentFilter.currentFilterTypeSelected = currentFilter.currentFilterTypes[type];
    this.filteringTicketsByStatus();
    this.cdr.markForCheck();
  }

  public onResetCheckedTickets(): void {
    const ticketsMultipleAssign = this.ticketsMultipleAssign;

    // Сбрасываем чекбоксы в основном списке
    each(this.tickets.dataFlatList, (ticket) => {
      ticket.isChecked = false;
    });

    // Также сбрасываем чекбоксы в матричном режиме
    if (this.tickets.dataMatrix) {
      each(this.tickets.dataMatrix, (dateData) => {
        if (dateData.intervals && dateData.intervals.intervals) {
          each(dateData.intervals.intervals, (interval) => {
            if (interval.tickets) {
              each(interval.tickets, (ticket) => {
                ticket.isChecked = false;
              });
            }
          });
        }
      });
    }

    ticketsMultipleAssign.ticketsChecked = null;
    ticketsMultipleAssign.isExistCheckedTicket = false;
  }

  public ticketsListRefresh(): void {
    const filter = this.ticketsCurrentFilter;

    if (this.checkAssignedTickets()) {
      this.onAssignedConfirmDialog().result.then(
        () => {
          filter.currentFilterTypeSelected = filter.currentFilterTypes.all;
          this.brigadeAssignData.brigades = [];
          this.brigadeAssignData.isAssignedSuccess = false;
          this.getBrigadesAndTickets();
        },
        () => {}
      );
    } else {
      filter.currentFilterTypeSelected = filter.currentFilterTypes.all;
      this.brigadeAssignData.brigades = [];
      this.brigadeAssignData.isAssignedSuccess = false;
      this.getBrigadesAndTickets();
    }
  }

  public onChangeMode(mode): void {
    this.ticketsCurrentFilter.mode = mode;
  }
}
